import React from "react";
import PropTypes from "prop-types";
import { useTimeLineNavigation } from "~/components/Hooks";
import { TaskSheet } from "./TaskSheet";

export const TimeLineNavigation = React.forwardRef(({ taskId, ...props }, ref) => {
  const [prev, next] = useTimeLineNavigation(taskId);
  return (
    <TaskSheet
      ref={ref}
      taskId={taskId}
      prev={prev}
      next={next}
      {...props}
    />
  );
});

TimeLineNavigation.propTypes = {
  taskId: PropTypes.number,
};

TimeLineNavigation.displayName = "TimeLineNavigation";
